// extracted by mini-css-extract-plugin
module.exports = {"brand":"styles-module--brand--2FsKA","logo":"styles-module--logo--1oWtR","rank":"styles-module--rank--1e_ip"};